// Types
import type { IImportModel, TImportParams, TImportResponse } from '~/shared/import/types';
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';

// Models
import { ManagerCompanyModel } from '~/modules/manager/models/company.model';

export class ManagerImportResolver implements IImportModel {
  protected model: ManagerCompanyModel = new ManagerCompanyModel();

  constructor(protected companyId: number) {}

  process(
    params: TImportParams,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TImportResponse> {
    return this.model.import(this.companyId, params, requestConfig);
  }
}
